/**
 * Created by mh on 2017/8/6.
 */
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { observable } from 'mobx';
import { observer, inject } from 'mobx-react';
import ChannelTableRowComponent from './ChannelTableRow';

import Spinner from '../Spinner';

import Store from './model/ChannelStore';

import TableLimit from '../core/TableLimit';
import TableFilter from '../core/TableFilter';
import TableSummary from '../core/TableSummary';
import TablePagination from '../core/TablePagination';

import { MdRefresh } from 'react-icons/md';

@inject('auth') @observer
class ChannelTable extends React.Component {
    componentDidMount = () => {
        this.store.page = this.props.match.params.page ? this.props.match.params.page - 1 : 0;
        this.store.type = this.props.match.params.type;
        this.reload();
        // this.store.syncUpdate();
    };
    componentWillReceiveProps = (nextProps) => {
        // TODO is this right ?
        if (nextProps.match.params.type !== this.props.match.params.type) {
            this.store.type = nextProps.match.params.type;
            this.store.fetch();
        }
        if (nextProps.match.params.page !== this.props.match.params.page) {
            this.store.page = nextProps.match.params.page ? nextProps.match.params.page - 1 : 0;
            this.store.fetch();
        }
    };
    componentWillUnmount = () => {
        // this.store.unsyncUpdates();
    };

    @observable store = Store.fromJS(this.props.auth, []);

    reload = () => {
        this.store.page = 0;
        this.store.fetch();
    };
    myAction = () => {
    };

    render() {
        return (
            <div className="table-responsive">
                <div className="row">
                    <div className="mx-auto">
                        <TablePagination store={this.store} />
                    </div>
                    <div className="form-inline">
                        <TableFilter store={this.store} />
                        <TableLimit store={this.store} />
                        <div className="btn btn-secondary" onClick={this.reload} onKeyDown={this.myAction}>
                            <MdRefresh />
                        </div>
                    </div>
                </div>
                {this.store.fetching ? <Spinner /> : (
                    <table className="table table-sm table-striped table-delivermedia">
                        <thead>
                            <tr>
                                <th>
                                    <FormattedMessage id="Channels.Type" defaultMessage="Type" />
                                </th>
                                <th>
                                    <FormattedMessage id="Channels.Name" defaultMessage="Name" />
                                </th>
                                <th>
                                    <FormattedMessage id="Channels.Actions" defaultMessage="Actions" />
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.store.filtered ?
                                this.store.filtered.map(channel => (<ChannelTableRowComponent
                                    channel={channel}
                                    key={channel.id} />))
                                : (
                                    <tr>
                                        <td>
                                            <FormattedMessage
                                                id="Channels.NoChannelsFound"
                                                defaultMessage="No Channels Found" />
                                        </td>
                                    </tr>
                                )}
                        </tbody>
                    </table>
                )}
                <TableSummary store={this.store} />
            </div>);
    }
}

ChannelTable.wrappedComponent.propTypes = {
    auth: PropTypes.object.isRequired,
    match: PropTypes.object.isRequired,
};

export default injectIntl(ChannelTable);
